import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=477fb48b&scoped=true&"
import script from "./AppCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=477fb48b&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477fb48b",
  null
  
)

export default component.exports